module.exports = __webpack_public_path__ + "static/img/花瓶15.7891579.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶15.png
// module id = dA/t
// module chunks = 2